<template>
  <div>
    
    <div class="cardContainer evaluationHeader" style="padding: 30px">
    <h5 class="medium-title">{{$t('label_evaluation_auditRecords_title')}}</h5>
        <div style="text-align: right;">
            <b-button variant="primary" @click="isModalOpen = true">
            <i class="bi bi-plus"></i>
            {{ $t("label_evaluation_add_record_button") }}
            </b-button>
        </div>
        <div
          v-for="(category, index) of categories"
          :key="index"
        >
          <expandible-section :records="records[index]" :thumbnailsAvailable="category.thumbnailsAvailable" @reload="getRecords">
          <template #title>
            {{$t(category.name)}}
          </template>
    </expandible-section>
        </div>

    </div>

    <upload-record-modal :showModal.sync="isModalOpen" :categories="categories" @loading="$emit('update:loading')" @reload="getRecords" />
    
  </div>
</template>
<script>
import UploadRecordModal from "./UploadRecordModal.vue" 
import ExpandibleSection from "./ExpandibleSection.vue";
import { cloneDeep } from "lodash";
import { mapGetters } from "vuex";
import { axiosCall } from "../../../../utils/axiosCall";

export default {
  name: "EvaluationRecordsTab",
  components: {ExpandibleSection, UploadRecordModal },
  data() {
    return {
      isModalOpen: false,
      evaluationId: this.$route.params.idEvaluation,
      categories: [
        {name: 'label_evaluation_auditRecords_auditItinerary', thumbnailsAvailable: false},
        {name: 'label_evaluation_auditRecords_attendanceRecords', thumbnailsAvailable: false},
        {name: 'label_evaluation_auditRecords_photosOfTheProccess', thumbnailsAvailable: true},
        {name: 'label_evaluation_auditRecords_otherDocuments', thumbnailsAvailable: false},
      ],
      records: [],
      loading: false
    };
  },
  async mounted() {
    await this.getRecords()
  },
  computed: {
    ...mapGetters(["getUserAccount"]),
  },

  methods: { 
    getRecords: async function () {
      this.records = [[], [], [], []]
      this.$emit('update:loading', true)
      await axiosCall({ url: "Records/" + this.evaluationId, method: "GET"
      }).then((response) =>{
        response.data.map((record) => {
            this.records[record.category].push(record)
          })
        });
      this.$emit('update:loading', false)
    },
    }
  }
</script>
<style scoped lang="scss" scoped>

@import "../../../../assets/css/variables";

.medium-title{
  text-align: center;
  font-size: 20px;
  font-family: $font-subtitle;
  text-transform: uppercase;
  }
</style>
